export default __webpack_public_path__ + "static/media/midasi_entry_zh_cn_pc@2x.6af1c77e.png";